import React, { useState } from 'react';
import { motion, useMotionValue, useSpring, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

// 1. ADDED isPriority TO THE PROPS HERE
const Projects = ({ projectDetails, isPriority }) => {
  const [isHovering, setIsHovering] = useState(false);

  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  const circleSpringX = useSpring(mouseX, { stiffness: 200, damping: 25 });
  const circleSpringY = useSpring(mouseY, { stiffness: 200, damping: 25 });

  const textSpringX = useSpring(mouseX, { stiffness: 180, damping: 20 });
  const textSpringY = useSpring(mouseY, { stiffness: 180, damping: 20 });

  const handleMouseEnter = (e) => {
    if (window.innerWidth < 768) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const startX = e.clientX - rect.left;
    const startY = e.clientY - rect.top;

    mouseX.set(startX);
    mouseY.set(startY);

    circleSpringX.jump(startX);
    circleSpringY.jump(startY);
    textSpringX.jump(startX);
    textSpringY.jump(startY);

    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  const handleMouseMove = (e) => {
    if (window.innerWidth < 768) return;
    const rect = e.currentTarget.getBoundingClientRect();
    mouseX.set(e.clientX - rect.left);
    mouseY.set(e.clientY - rect.top);
  };

  if (!projectDetails) return null;

  return (
    // Reverted the outer wrapper to your original logic, but protected desktop with lg:
    <div className='w-full lg:w-auto px-2'>
      <Link to={`/portfolio/${projectDetails.id}`} className="block">
        <div
          // KEY FIX: Tablet gets w-full (to respect the grid gaps), Desktop (lg) gets w-180
          className='relative text-black w-full lg:w-180 cursor-pointer'
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onMouseMove={handleMouseMove}
        >
          <div
            // SCALED DOWN: Tablet gets h-96 and p-10. Desktop remains h-160 and p-16. Mobile remains h-100 and p-8.
            className='group flex items-center justify-center h-90 md:h-96 lg:h-160 p-8 md:p-10 lg:p-16'
            style={{ backgroundColor: projectDetails.bgColor || '#000000' }}
          >
            <img
              src={projectDetails.imageUrl}
              alt={projectDetails.projectName}
              className='h-full w-full object-contain transition-transform duration-500 ease-in-out group-hover:scale-105'
              
              /* 2. ADDED THE LCP MAGIC FIX HERE */
              fetchPriority={isPriority ? "high" : "auto"}
              loading={isPriority ? "eager" : "lazy"}
            />
          </div>

          <div className='my-8 md:my-10 lg:my-14'>
            {/* SCALED DOWN: Tablet text is 3xl. Desktop remains 4xl. Mobile remains 2xl. */}
<h3 className='uppercase text-2xl md:text-3xl lg:text-4xl font-medium'>
    {projectDetails.title || projectDetails.projectName}
  </h3>
  
  <hr className="h-px border-0 bg-zinc-300 my-4 md:my-5 lg:my-6" />
  
  <div className='flex justify-between text-base md:text-lg lg:text-xl'>
    {/* These are fine as h3 or p since they follow an h3 title */}
    <p>{projectDetails.category}</p>
    <p>{projectDetails.year}</p>
  </div>
          </div>

          <AnimatePresence>
            {isHovering && (
              <>
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1.25 }}
                  exit={{ scale: 0 }}
                  transition={{ duration: 0.2 }}
                  className="absolute bg-blue-500 rounded-full shadow-lg pointer-events-none"
                  style={{
                    x: circleSpringX,
                    y: circleSpringY,
                    translateX: "-50%",
                    translateY: "-50%",
                    width: '6rem',
                    height: '6rem',
                    top: 0,
                    left: 0,
                    zIndex: 20,
                  }}
                ></motion.div>

                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1.25 }}
                  exit={{ scale: 0 }}
                  transition={{ duration: 0.2 }}
                  className="absolute pointer-events-none text-white text-xs font-bold whitespace-nowrap flex justify-center items-center"
                  style={{
                    x: textSpringX,
                    y: textSpringY,
                    translateX: "-50%",
                    translateY: "-50%",
                    top: 0,
                    left: 0,
                    zIndex: 30,
                  }}
                >
                  VIEW
                </motion.div>
              </>
            )}
          </AnimatePresence>
        </div>
      </Link>
    </div>
  );
};

export default Projects;